export const  Products = [
    {
      id: 1,
      name: "Infinity-X",
      description: "Noise-canceling over-ear headphones with up to 30 hours of battery life.",
      price: "79.99",
      category: "Electronics",
      brand: "AudioPlus",
      stock: 120,
      rating: 4.5,
      likes: 320,
      highest: "90.00",
      img: "https://example.com/images/headphones.jpg",
      isClass: "highlight"
    },
    {
      id: 2,
      name: "Infinity-ERP",
      description: "6.1-inch display, triple-lens camera, and A15 Bionic chip.",
      price: "999.99",
      category: "Electronics",
      brand: "TechZone",
      stock: 50,
      rating: 4.8,
      likes: 210,
      highest: "1,050.00",
      img: "https://example.com/images/smartphone.jpg",
      isClass: ""
    },
    {
      id: 3,
      name: "Infinity-Fleet",
      description: "Lightweight and breathable running shoes with superior cushioning.",
      price: "59.99",
      category: "Footwear",
      brand: "RunFast",
      stock: 200,
      rating: 4.3,
      likes: 150,
      highest: "65.00",
      img: "https://example.com/images/runningshoes.jpg",
      isClass: "popular"
    },
    {
      id: 3,
      name: "AT YOUR SERVICE (AYS)",
      description: "Lightweight and breathable running shoes with superior cushioning.",
      price: "59.99",
      category: "Footwear",
      brand: "RunFast",
      stock: 200,
      rating: 4.3,
      likes: 150,
      highest: "65.00",
      img: "https://example.com/images/runningshoes.jpg",
      isClass: "popular"
    },
   
  ];
  